import { ReactElement, useEffect } from 'react'
import { Box, Typography, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { updateLoader } from '../../redux/slices/loaderSlice'
import { useTranslation } from 'react-i18next'

export default function NotFoundPage(): ReactElement {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const isLoading = useAppSelector((state) => state.loader.loader) || false

    useEffect(() => {
        /**
         * By default the app starts with loader as true. This is set to false
         * after the user is logged in and an org is set. For guest user these
         * steps are not followed. Hence we are setting false here.
         */
        if (isLoading) {
            dispatch(updateLoader(false))
        }
    }, [])
    return (
        <Box textAlign="center" p={4}>
            <Typography variant="h4" gutterBottom>
                {t('notFoundTitle')}
            </Typography>
            <Typography variant="body1" paragraph>
                {t('notFoundMessage')}
            </Typography>
            <Button variant="contained" color="primary" component={Link} to="/">
                {t('goToHome')}
            </Button>
        </Box>
    )
}
